import React, { useEffect, useState } from "react";
import { Table, TableColumn } from "../../../components/table";
import HeaderBar from "../../../components/header/headerBar";
import IconMdi from "@mdi/react";
import { mdiPencilCircle, mdiDelete, mdiPlus } from "@mdi/js";
import { SearchField } from "../../../components/textfield";
import Select from "../../../components/select/select";
import Button from "../../../components/button/Button";
import Import from "../../../components/button/Import";
import { useHistory } from "react-router-dom";
import { Modal, Checkbox } from "antd";
import { Icon } from "@iconify/react";
import moment from "moment";
import axios from "axios";
const ReplyList = () => {
  const { confirm } = Modal;
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [state, setState] = useState<any>({
    data: [],
  });
  const [data, setData] = useState([]);

  const columns = [
    {
      title: "ลำดับNo.",
      align: "center",
    },
    {
      title: "",
    },
    {
      title: "เลขที่ใบตอบกลับ<br/>Reply  Number",
      align: "center",
    },
    {
      title: "เลขที่ใบคำขอ<br>Request Number",
      align: "center",
    },
    {
      title: "จากสาขา<br/>Branch From",
      align: "center",
    },
    {
      title: "สาขาที่ขอ<br/>Branch Request",
      align: "center",
    },
    {
      title: "ประเภทคำขอ<br/>Type Request",
      align: "center",
    },
    {
      title: "วันที่<br/>Date",
      align: "center",
    },
    {
      title: "สถานะ<br/>Status",
      align: "center",
    },
    {
      title: "แก้ไข<br/>Edit",
      align: "center",
    },
    {
      title: "ลบ<br/>Delete",
      align: "center",
    },
  ];



  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        axios.delete(`/stock-requests/delete/${id}`).then((res) => {
          getData();
        });
      },
      width: "fit-content"
    });
  }

  useEffect(() => {
    getData();
  }, []);
  const createRequest = () => {
    axios.post(`/stock-requests/mockup`).then((res) => {
      if (res.status === 200)
        history.push(`/setting/inventory/request/${res.data.dataList?._id}/create/`)
    });
  }
  const getData = () => {
    axios.get(`/stock-requests/map`).then((res) => {
      setData(res?.data?.data)
    });
  }
  return (
    <div>
      <HeaderBar title="Reply list" />

      <div style={{ padding: "10px 40px" }}>
        <SearchField placeholder="Search for  Code" color="#fff" />
        <div style={{ marginTop: "100px" }}>
          <Table header={columns}>
            {data.map((item: any, index: number) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="3%" align="center">
                  <Checkbox />
                </TableColumn>
                <TableColumn width="20%">{item?.replyCode}</TableColumn>
                <TableColumn width="20%">{item.requestNumber}</TableColumn>
                <TableColumn width="10%">{item.fromBranch?.name}</TableColumn>
                <TableColumn width="10%">{item.goBranch?.name}</TableColumn>
                <TableColumn width="20%">{item.requestType} {(item.urgent === true) && <span style={{ color: "red" }}> - เร่งด่วน </span>}</TableColumn>
                <TableColumn width="20%">{moment(item?.requestDate).format('DD-MM-YYYY')}</TableColumn>
                <TableColumn width="15%">
                  <div
                    className={`${item.status === "Pending" || !item.status
                      ? "pending-status"
                      : item.status === "Approved"
                        ? "success-status"
                        : "close-status"
                      }`}
                  >
                    {item.status || "Pending"}
                  </div>
                </TableColumn>


                <TableColumn width="5%" align="center">

                  <div
                    onClick={() => {
                      history.push(
                        `/setting/inventory/reply/${item?._id}`
                      );
                    }}
                  >
                    <IconMdi path={mdiPencilCircle} size="30" color="#5BAEA9" />
                  </div>
                </TableColumn>
                <TableColumn
                  width="5%"
                  align="center"
                  onClick={() => {
                    showDeleteConfirm(item._id, item.requestNumber)
                  }}
                >
                  <div>
                    <IconMdi path={mdiDelete} size="25" color="#FF6760"></IconMdi>
                  </div>
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
      </div>
    </div>
  );
};
export default ReplyList;
